<div class="card-body">
	<div class="row">
		<div class="col form-group">
			<label for="start" class="form-label">Fecha inicio:</label>
			<input type="date" name="start" id="start" (change)="updateChart()" [(ngModel)]="start"
				class="form-control">
		</div>
		<div class="col form-group">
			<label for="end" class="form-label">Fecha final:</label>
			<input type="date" name="end" id="end" (change)="updateChart()" [(ngModel)]="end" class="form-control">
		</div>
		<div class="col form-group">
			<label for="option" class="form-label">
				Tipo:
			</label>
			<select name="option" id="option" [class.required]="!option" (change)="updateChart()" class="form-select"
				[(ngModel)]="option">
				<option [ngValue]="null">Selecciona un tipo
				</option>
				<option *ngFor="let o of options" [ngValue]="o.id">{{o.name}}</option>
			</select>
		</div>
		<div class="col form-group">
			<label for="stational" class="form-label">Estacionalidad:</label>
			<select name="stational" id="stational" [(ngModel)]="type" (change)="updateChart()" class="form-select">
				<option [ngValue]="0">RESUMEN</option>
				<option [ngValue]="1">AÑOS</option>
				<option [ngValue]="2">MESES</option>
				<option [ngValue]="3">DIAS</option>
			</select>
		</div>
	</div>

	<div class="relative-graph" style="min-height: 350px;">
		<div id="billpay-chronology"></div>
		<div class="absolute-loading" *ngIf="loadingChart && option">
			<span class="display-5 text-center">
				<app-loading-animation [height]="'3rem'"></app-loading-animation>
				Cargando...
			</span>
		</div>
		<div class="absolute-loading" *ngIf="!loadingChart && results.length == 0 && option">
			<span class="display-5 text-center">
				<div class="empty-icon-container">
					<div class="empty-icon-animation">
						<i class="fa-solid fa-exclamation"></i>
					</div>
					<i class="fa fa-box-open"></i>
				</div>
				No se cuenta con registros
			</span>
		</div>
		<div class="absolute-loading" *ngIf="!option">
			<span class="display-5 text-center">
				<div class="point-icon-container">
					<div class="point-icon-animation">
						<i class="fa-solid fa-hand-point-left"></i>
					</div>
					<i class="fa fa-list"></i>
				</div>
				Selecciona un <b>tipo</b> primero
			</span>
		</div>
	</div>
</div>